import React, { useState, useEffect } from 'react';
import './App.css';
import ChercherO2 from './components/ChercherO2'
import Footer from './components/Footer';
import Button from '@material-ui/core/Button';
import { getWilayaList } from '@dzcode-io/leblad';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

function App() {

  const [giverList, setGiverList] = useState([]);

  function handleWilayasChanges(event) {
    fetchGiverList(event.value)
  }

  async function fetchGiverList(wilaya) {
    try {
      const requestUrl = 'https://dzoxygen.000webhostapp.com/getGiverByWilaya.php?wilaya=' + wilaya;
      const response = await fetch(requestUrl);
      const responseJson = await response.json();
      setGiverList(responseJson.data)
    } catch {
      console.log("error")
    }
  }

  useEffect(() => {
    fetchGiverList(31)
  }, []);

  const allWilayasDetails = getWilayaList();

  const options = allWilayasDetails.map(wilaya => ({ label: wilaya.name, value: wilaya.mattricule }))

  const ExternalRedirect = ({ to, ...routeProps }) => {
    return <Route {...routeProps} render={() => window.location = to} />;
  };

  return (
    <div>
      <Router>
        <div>
          <img className="button" src={process.env.PUBLIC_URL + "DZ.png"} alt="DzOxygenLogo" style={{ maxWidth: "100px" }} />
          {/* <Link style={{ borderBottom: "none", textDecoration: 'none' }} to="/cherchero2">
            <div className="button">
              <Button size="small" uppercase={false} variant="contained" color="primary"  >Chercher de l'oxygène<br></br>ابحث عن الأكسجين</Button>
            </div>
          </Link> */}
          <Link style={{ borderBottom: "none", textDecoration: 'none' }} to={{ pathname: "https://docs.google.com/forms/d/e/1FAIpQLSdhPTGOFyb2MtNX94EPHzlgXn4FCqlged_QddeJ3dw7NzlkAg/viewform?usp=pp_url" }} target="_blank">
            <div className="button">
              <Button size="small" uppercase={false} variant="contained" color="primary" >J'ai des informations sur l'oxygène<br></br>لدي معلومات عن الأكسجين</Button>
            </div>
          </Link>
          <Link style={{ borderBottom: "none", textDecoration: 'none' }} to={{ pathname: "https://docs.google.com/forms/d/e/1FAIpQLSf1taQO29OqYeHD1npvQwcNm_tWUaMA4tvZNjgwtjxIln8xow/viewform?usp=pp_url" }} target="_blank">
            <div className="button">
              <Button size="small" uppercase={false} variant="contained" color="primary" >Je veux aider cette initiative<br></br>أريد أن أساعد هذه المبادرة</Button>
            </div>
          </Link>
          <Switch>
            <Route path="/">
              <ChercherO2 />
            </Route>
          </Switch>
        </div>
      </Router >
      <h2 className="button">
        Alternatives : البدائل
      </h2>
      <Router>
        <Link style={{ borderBottom: "none", textDecoration: 'none' }} to={{ pathname: "https://oxygenedz.com/" }} target="_blank">
          <div className="button">
            <Button size="small" uppercase={false} variant="contained" color="primary" >oxygenedz.com</Button>
          </div>
        </Link>
        <Link style={{ borderBottom: "none", textDecoration: 'none' }} to={{ pathname: "https://sos-oxygene.com/" }} target="_blank">
          <div className="button">
            <Button size="small" uppercase={false} variant="contained" color="primary" >sos-oxygene.com</Button>
          </div>
        </Link>
        <Link style={{ borderBottom: "none", textDecoration: 'none' }} to={{ pathname: "https://www.linkedo2.xyz/" }} target="_blank">
          <div className="button">
            <Button size="small" uppercase={false} variant="contained" color="primary" >linkedo2.xyz</Button>
          </div>
        </Link>
      </Router>
      <Footer />
    </div>
    // <div >
    //   <img className="button" src={process.env.PUBLIC_URL + "DZ.png"} alt="DzOxygenLogo" style={{ maxWidth: "200px" }} />
    //   <div className="button">
    //     <Button variant="contained" color="primary"  >Chercher de l'oxygène</Button>
    //   </div>
    //   <div className="button">
    //     <Button variant="contained" color="primary" >Fournir de l'oxygène</Button>
    //   </div>
    //   <div className="button">
    //     <Button variant="contained" color="primary" >Aider cette initiative</Button>
    //   </div>
    // </div>
    // <div className="App">
    //   <img src={process.env.PUBLIC_URL + "DZ.png"} alt="DzOxygenLogo" style={{ maxWidth: "100px" }} />
    //   <CustomSelect className="CustomSelect" defaultValue={options[30]} onChange={handleWilayasChanges} options={options} label="Choisir Wilaya" />
    //   <GetList className="GetList" giverList={giverList} />
    // </div>
  );
}

export default App;
